let event = require("cocos/framework/components/event");
/**
 * 关末复活礼包视图
 */
var TrinityGiftBagView = xClass("TrinityGiftBagView", event, function () {
    return cc.CSLoader.createNode("cocos/trinity_gift_trinity_gift_gift.csb");
})

const RES = ["packed/TrinityGiftBagView.pack"];

TrinityGiftBagView.preloadRes = function (onSuccess, onFail, onCancel, useMask = false) {
    preloadWithLoading(RES, onSuccess, onFail, onCancel, useMask)
}

TrinityGiftBagView.prototype.ctor = function (dcData = {}) {
    let self = this;
    self.bind(self);
    self.dcData =  JSON.parse(JSON.stringify(dcData));
    //
    self.TrinityGiftBagMgr = TrinityGiftBagManager.getInstance();
    const entry = "stage_end";
    self.TrinityGiftBagMgr.fromToPanel = entry;
    self.dcData.scence = entry;
    self.dcData.entry = entry;
    DCAssist.dc4ShowCashGoods(entry, entry, [self.TrinityGiftBagMgr.info.giftBagIds[4]], null, null, self.dcData);
    self.initUI();
    self.popup();
}

TrinityGiftBagView.prototype.popup = function () {
    let self = this
    //
    self.isBusy = true;
    function onEnter() {
        self.isBusy = false;
    }
    self.setScale(0);
    self.runAction(cc.Sequence.create(cc.ScaleTo.create(0.33, 1), cc.CallFunc.create(onEnter)));
}

TrinityGiftBagView.prototype.initUI = function () {
    let self = this;
    let btn = self.getChildByName("btn");
    let btn_info = self.getChildByName("endgift_btn_info");
    let bg_2 = self.getChildByName("bg_2");
    let bg_1 = self.getChildByName("bg_1");
    //
    const id = self.TrinityGiftBagMgr.info.giftBagIds[4];
    let rewards = [];
    let cfg = self.TrinityGiftBagMgr.getRewardById(id);
    if (cfg) {
        // cfg.itemRewards = "14:50,10018:5,10240:10,10019:5";
        // cfg.itemRewards = "14:50,10018:3,10003:2,10240:10,10019:2";
        // cfg.itemRewards = "14:50,10018:3,10003:2,10011:3,10019:2,10240:10";
        let list = cfg.itemRewards.split(",");
        //
        for (let j = 0; j < list.length; j++) {
            const arr = list[j].split(":");
            const itemId = Number(arr[0]);
            const num = Number(arr[1]);
            rewards.push({ itemId, num });
        }
        //
        const len = rewards.length - 1;
        let idx = 0;
        for (let i = 0; i <= len; i++) {
            const itemId = rewards[i].itemId;
            const num = rewards[i].num;
            //
            let num_label = cc.LabelBMFont.create("x" + num, "font/berlinsansfb_40_lightbrownstroke.fnt");
            let icon = null;
            if (itemId == 14) {
                icon = UIItemBuilder.createCashSprite(cfg.price);
                icon.setScale(0.37);
                icon.setPosition(bg_1.width / 2, bg_1.height / 2 + 10);

                num_label.setScale(0.8);
                num_label.setPosition(icon.x, icon.y - 40);
                bg_1.addChild(icon);
                bg_1.addChild(num_label);
            } else {
                icon = UIItemBuilder.createProp(itemId)[0];
                let posX = 0;
                let posY = 0;
                if (len > 4) {
                    icon.setScale(0.55);
                    let arr = [-60, 0, 60, -30, 30];
                    posX = arr[idx];
                    posY = idx < 3 ? 43 : -30;
                    num_label.setScale(1.27);
                    num_label.setPosition(icon.width / 2, -10);
                } else if (len == 4) {
                    icon.setScale(0.6);
                    posX = (idx - 1.5) * 60;
                    posY = 10;
                    num_label.setScale(1.33);
                    num_label.setPosition(icon.width / 2, -18);
                } else {
                    icon.setScale(0.8);
                    posX = (idx - 1) * 80;
                    posY = 15;
                    num_label.setPosition(icon.width / 2, -10);
                }
                icon.setPosition(bg_2.width / 2 + posX, bg_2.height / 2 + posY);
                icon.addChild(num_label);
                bg_2.addChild(icon);
                idx++;
            }
        }
        btn.getChildByName("txt").setString("￥" + cfg.price + "超值打包");
    }
    //
    let buySucc = function () {
        ActivityGetRewardsPanel.show({
            type: 1,
            // add_model: ModuleName.TRINITY_GIFT_BAG,
            rewardList: rewards,
            tobagAni: true,
            title: "normal",
            closeCb: () => {
                self.removeFromParent(true);
            }
        })
    }

    quickBuildUIButton(btn, () => {
        if (self.isBusy) return;
        self.isBusy = true;
        self.dcData.goodsId = id;
        self.TrinityGiftBagMgr.clickBuyGoods(id, self.dcData, (buy) => {
            if (buy) {
                buySucc();
                self.isBusy = false;
            } else {
                if (!self.TrinityGiftBagMgr.isOpen()) {
                    self.TrinityGiftBagMgr.triggerBuySucc(false);
                    return;
                }
                self.isBusy = false;
            }
        });
    })

    quickBuildUIButton(btn_info, () => {
        if (self.isBusy) return;
        self.isBusy = true;
        //
        self.TrinityGiftBagMgr.openPanel(() => {
            self.isBusy = false;
        })
    })
}

TrinityGiftBagView.prototype.onCleanup = function () {
    let self = this;
    self.TrinityGiftBagMgr.buySucc = null;
    ResManager.release(RES);
}

module.exports = TrinityGiftBagView
